import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  getConfiguracionById,
  postConfiguracion,
  updateConfiguracion,
} from "../../../../api/configuracion";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { decryptPassword, encrypt } from "../../../../utils/helpers";
import HtmlEditor from "../../../components/htmlEditor/HtmlEditor";

export default function EditConfiguracionesPage() {
  const [configuracion, setConfiguracion] = useState({});
  const [firmaEditando, setFirmaEditando] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const configuracionId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!configuracionId) {
      disableLoadingData();
      alertError({
        error: null,
        customMessage: "Could not get configuracion.",
      });
      return history.push("/dashboard");
    }
    getConfiguracionById(configuracionId)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;

          for (let item of data.car) {
            for (let lang in item.passwordHost) {
              item.passwordHost[lang] = decryptPassword(
                item.passwordHost[lang]
              );
            }
          }
          for (let item of data.bike) {
            for (let lang in item.passwordHost) {
              item.passwordHost[lang] = decryptPassword(
                item.passwordHost[lang]
              );
            }
          }

          setConfiguracion(data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get configuracion.",
        });
        history.push("/dashboard");
      });
  }, [configuracionId, refresh, disableLoadingData, history]);

  function saveConfiguracion() {
    const configToSave = JSON.parse(JSON.stringify(configuracion));

    ["car", "bike"].forEach((tipo) => {
      if (Array.isArray(configToSave[tipo])) {
        configToSave[tipo] = configToSave[tipo].map((item) => {
          if (item.passwordHost) {
            return {
              ...item,
              passwordHost: encrypt(item.passwordHost),
            };
          }
          return item;
        });
      }
    });
    updateConfiguracion(configuracionId, configToSave)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          setFirmaEditando(null);
          setRefresh((prev) => !prev);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const handleChangeEditor = (lang, value, ix, tipo) => {
    if (lang) {
      if (value === " ") return;
      const updated = [...configuracion[tipo]];
      if (!updated[ix].firma) updated[ix].firma = {};
      updated[ix].firma[lang] = value;
      setConfiguracion({
        ...configuracion,
        [tipo]: updated,
      });
    }
  };

  const renderMultilanguageTabContent = (lang, item, ix, tipo) => {
    return (
      <>
        <HtmlEditor
          body={(item.firma && item.firma[lang]) || ""}
          setBody={(new_body) => handleChangeEditor(lang, new_body, ix, tipo)}
          className="max-height"
          lang={lang}
          placeholder="Enter html firma here..."
        />
      </>
    );
  };
  const renderMultilanguageTabAgente = (lang, item, index, tipo) => {
    return (
      <div
        key={index}
        style={{
          border: "1px solid #ccc",
          borderRadius: 8,
          padding: 16,
          marginBottom: 20,
        }}
      >
        <div className="col-md-12">
          <TextField
            label="Host"
            value={item.host?.[lang] || ""}
            onChange={(e) => {
              const updated = [...configuracion[tipo]];
              updated[index].host = {
                ...updated[index].host,
                [lang]: e.target.value,
              };
              setConfiguracion({
                ...configuracion,
                [tipo]: updated,
              });
            }}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </div>
        <div className="d-flex">
          <div className="col-md-6">
            <TextField
              label="Nombre completo"
              value={item.fullName?.[lang] || ""}
              onChange={(e) => {
                const updated = [...configuracion[tipo]];
                updated[index].fullName = {
                  ...updated[index].fullName,
                  [lang]: e.target.value,
                };
                setConfiguracion({
                  ...configuracion,
                  [tipo]: updated,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-6">
            <TextField
              label="Email"
              value={item.email?.[lang] || ""}
              onChange={(e) => {
                const updated = [...configuracion[tipo]];
                updated[index].email = {
                  ...updated[index].email,
                  [lang]: e.target.value,
                };
                setConfiguracion({
                  ...configuracion,
                  [tipo]: updated,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
            />
          </div>
        </div>
        <div className="d-flex">
          <div className="col-md-6">
            <TextField
              label="URL Calendly"
              value={item.urlCalendly?.[lang] || ""}
              onChange={(e) => {
                const updated = [...configuracion[tipo]];
                updated[index].urlCalendly = {
                  ...updated[index].urlCalendly,
                  [lang]: e.target.value,
                };
                setConfiguracion({
                  ...configuracion,
                  [tipo]: updated,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-6">
            <TextField
              label="Password Host"
              value={item?.passwordHost?.[lang] || ""}
              onChange={(e) => {
                const updated = [...configuracion[tipo]];
                updated[index].passwordHost = {
                  ...updated[index].passwordHost,
                  [lang]: e.target.value,
                };
                setConfiguracion({
                  ...configuracion,
                  [tipo]: updated,
                });
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              type="password"
            />
          </div>
        </div>
        {!(firmaEditando?.index === index && firmaEditando?.tipo === tipo) ? (
          <div className="col-md-12">
            <Button onClick={() => setFirmaEditando({ index, tipo })}>
              Editar Firma
            </Button>
          </div>
        ) : (
          <div className="col-md-12 mt-4">
            <MultilanguageTabBlock
              multilanguageTabContent={renderMultilanguageTabContent}
              ix={index}
              tipo={tipo}
              item={item}
            />
          </div>
        )}
        <div className="col-md-12">
          <FormControlLabel
            control={
              <Checkbox
                checked={item.active ?? true}
                onChange={(e) => {
                  const updated = [...configuracion[tipo]];
                  updated[index].active = e.target.checked;
                  setConfiguracion({
                    ...configuracion,
                    [tipo]: updated,
                  });
                }}
                name="checkActive"
              />
            }
            label="Activo"
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            color="secondary"
            style={{
              marginTop: 16,
              borderColor: "#f44336",
              color: "#f44336",
            }}
            onClick={() => {
              const updated = configuracion[tipo].filter((_, i) => i !== index);
              setConfiguracion({
                ...configuracion,
                [tipo]: updated,
              });
            }}
          >
            Eliminar
          </Button>
        </div>
      </div>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Edit configuracion"></CardHeader>
          <CardBody>
            <div className="d-flex">
              <div className="col-md-4">
                <TextField
                  label="Email logs"
                  value={configuracion.email || ""}
                  onChange={(e) => {
                    setConfiguracion({
                      ...configuracion,
                      email: e.target.value,
                    });
                  }}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Licencia del editor html de producción"
                  value={configuracion.licenciaEditorPro || ""}
                  onChange={(e) => {
                    setConfiguracion({
                      ...configuracion,
                      licenciaEditorPro: e.target.value,
                    });
                  }}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Licencia del editor html de desarrollo"
                  value={configuracion.licenciaEditorDev || ""}
                  onChange={(e) => {
                    setConfiguracion({
                      ...configuracion,
                      licenciaEditorDev: e.target.value,
                    });
                  }}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <br />
            <br />
            {["car", "bike"].map((tipo) => (
              <div key={tipo} style={{ marginBottom: 40 }}>
                <h3>{tipo === "car" ? "Coches" : "Motos"}</h3>
                {Array.isArray(configuracion[tipo]) &&
                  configuracion[tipo].map((item, index) => (
                    <MultilanguageTabBlock
                      multilanguageTabContent={renderMultilanguageTabAgente}
                      ix={index}
                      tipo={tipo}
                      item={item}
                    />
                  ))}
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    const updated = [...(configuracion[tipo] || [])];
                    updated.push({
                      fullName: "",
                      email: "",
                      urlCalendly: "",
                      active: true,
                    });
                    setConfiguracion({ ...configuracion, [tipo]: updated });
                  }}
                >
                  Añadir nuevo gestor
                </Button> */}
              </div>
            ))}
          </CardBody>
        </Card>
        <Button
          onClick={() => history.push("/dashboard")}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => saveConfiguracion()}
          variant="outlined"
          color="primary"
          style={{ marginRight: "20px" }}
        >
          Save configuracion
        </Button>
      </>
    );
}
